import { type TermLifeStepParams, insuredSumSchema } from '@flows/configs/de/termLife/steps/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'

export const insuredSum = (params: TermLifeStepParams) => {
  const schema = insuredSumSchema
  return {
    schema,
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_termLife:steps.insured_sum.title',
        },
      },
      {
        type: 'choice',
        options:
          schema.shape.products.shape.mga_term_life_insurance_de.shape.configuration_parameters.shape.insured_sum.options.map(
            (option) => ({
              value: option,
              label: {
                type: 'translatableText',
                translationKey: `sharedFlows_termLife:steps.insured_sum.options.${option}`,
              },
            })
          ),
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('insured_sum'),
      },
    ],
    onSubmit: {
      type: 'dispatchedHook',
      callbackConfig: {
        name: 'updateConsultationRequest',
        inputs: [],
        outputs: [],
      },
    },
    nextStep: 'employment_status',
    subFlow: SubFlow.TermLife,
  } as const satisfies AnyStepConfiguration
}
